import * as React from 'react'
import { Language } from '../../models/Enums'
import { useIntl } from 'react-intl'

import './LanguageSelector.scss'

export type LanguageSelectorProps = {
    language: Language
    onSelectLanguageCode: (language: Language) => void
    displayAs: "Button" | "Switch"
}

const LanguageSelector = ({ language, onSelectLanguageCode, displayAs: selectorType }: LanguageSelectorProps) => {
    const intl = useIntl()

    const selectToLanguageCode = language === 'Svenska'
        ? { code: 'gb', language: 'English' as Language }
        : { code: 'se', language: 'Svenska' as Language }

    return (
        <>
            {selectorType === "Button" &&
                <button
                    className='language-selector-button'
                    onClick={() => onSelectLanguageCode(selectToLanguageCode.language)}>
                    <img
                        loading="lazy"
                        width="30"
                        height="15"
                        src={`https://flagcdn.com/${selectToLanguageCode.code}.svg`}
                        alt={selectToLanguageCode.code}
                    />
                    <span>{intl.formatMessage({ id: `common.change-language` })}</span>
                </button>
            }
            {
                selectorType === "Switch" &&
                <div className='language-selector-flags'>
                  <img
                        src="https://hatscripts.github.io/circle-flags/flags/se.svg"
                        className={selectToLanguageCode.code === 'se' ? "Flag Inactive" : "Flag"}
                        onClick={() => onSelectLanguageCode(selectToLanguageCode.language)}
                        alt={selectToLanguageCode.code}
                    />
                    <img
                        src="https://hatscripts.github.io/circle-flags/flags/gb.svg"
                        className={selectToLanguageCode.code === 'gb' ? "Flag Inactive" : "Flag"}
                        onClick={() => onSelectLanguageCode(selectToLanguageCode.language)}
                        alt={selectToLanguageCode.code}
                    />
                </div>
            }
        </>)
}

export default LanguageSelector